export enum PimFormFieldNames {
  CompanyName = 'companyName',
  Phone = 'phone',
  RegistrationNumber = 'registrationNumber',
  Capital = 'capital',
  RcsCity = 'rcsCity',
  RcsNumber = 'rcsNumber',
  Rcp = 'rcp',
  ComplaintEmail = 'complaintEmail',
  /** Sélection {courtierId, tunnelIds[]}[] — paire mandant×tunnel. */
  Mandants = 'mandants',
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Username = 'username',
  Password = 'password',
  /** Codes référentiels des OUs de rattachement (multi-org : chaque mandant doit
   * partager au moins une de ces plateformes avec le PIM). */
  PlateformeIds = 'plateformeIds',
}
